import Vue from 'vue'
import dayjs from 'dayjs'
import defaultState from './state'

export default {
  init(state) {
    Object.assign(state, defaultState)
  },
  setDriverLocations(state, driverLocations) {
    const carStatusCount = {
      rest: 0,
      vacant: 0,
      dispatched: 0,
      hired: 0,
      shift: 0,
      logout: 0,
      disappear: 0,
      suspension: 0,
      total: driverLocations.length,
    }
    const now = dayjs()
    const updatedDriverLocations = []
    /* const markerDirverLocations = [] */
    for (const obj of driverLocations) {
      /* 若更新時間沒有介於現在時間向前推5min與現在時間向後推1min之間，則提報為失聯 */
      const now = dayjs()
      const plusOneMin = now.add(1, 'minute')
      const minusFiveMin = now.subtract(5, 'minute')
      const isDisappear =
        dayjs(obj.updated_at).isBefore(minusFiveMin) ||
        dayjs(obj.updated_at).isAfter(plusOneMin)
      if (isDisappear) {
        updatedDriverLocations.push({ ...obj, status: 6, statusName: '失聯' })
        carStatusCount.disappear += 1
      } else {
        /* 根據status計算車輛的狀態 */
        switch (obj.status) {
          case 0:
            carStatusCount.rest += 1
            obj.statusName = '休息中'
            break
          case 1:
            carStatusCount.vacant += 1
            obj.statusName = '空車'
            break
          case 2:
            carStatusCount.dispatched += 1
            obj.statusName = '派遣中'
            break
          case 3:
            carStatusCount.hired += 1
            obj.statusName = '載客中'
            break
          case 4:
            carStatusCount.shift += 1
            obj.statusName = '排班車'
            break
          case 5:
            carStatusCount.logout += 1
            obj.statusName = '登出'
            break
          /* case 6:
            carStatusCount.disappear += 1
            break */
          case 7:
            carStatusCount.suspension += 1
            obj.statusName = '停權'
            break

          default:
            break
        }
        updatedDriverLocations.push(obj)
      }
      /* var filter_driver_locations = data.filter((driver) => {
        if (driver.callNumber !== false) {
          if (this.sortBy) {
            return driver.status >= 0 && driver.status < 5
          } else {
            return true
          }
        }
      }) */
    }
    Vue.set(state, 'lastUpdate', now.format('HH:mm:ss'))
    Vue.set(state, 'driverLocations', updatedDriverLocations)
    /* Vue.set(state, 'markerDriverLocations', markerDirverLocations) */
    Vue.set(state, 'carStatusCount', carStatusCount)
  },
  setDriverOptions(state, driverOptions) {
    Vue.set(state, 'driverOptions', driverOptions)
  },
  setDriverOptionsLoading(state, isLoading) {
    Vue.set(state, 'isDriverOptionsLoading', isLoading)
  },
  setDriverInfo(state, driverInfo) {
    Vue.set(state, 'driverInfo', driverInfo)
  },
  initDriverInfo(state) {
    Object.assign(state.driverInfo, defaultState.driverInfo)
  },
  setSortBy(state, isSortBy) {
    Vue.set(state, 'sortBy', isSortBy)
  },
  setMarkerDriverLocation(state, markers) {
    Vue.set(state, 'markerDriverLocations', markers)
  },
  setDispatchInfo(state, info) {
    const dispatchInfo = {
      name: info.name,
      area_capacity: info.area_capacity,
      dispatch_strategy: info.dispatch_strategy,
      in_line_name1: info.scheduledName[0],
      in_line_name2: '',
      note: info.note,
    }
    if (info.scheduledName.length > 1) {
      dispatchInfo.in_line_name2 = info.scheduledName[1]
    }
    Vue.set(state, 'dispatchInfo', dispatchInfo)
  },
  initDispatchInfo(state) {
    Object.assign(state.dispatchInfo, defaultState.dispatchInfo)
  },
  setShiftInfo(state, info) {
    const shiftInfo = {
      name: info.name,
      area_capacity: info.area_capacity,
      in_line_time1_start: info.in_line_time1_start,
      in_line_time1_end: info.in_line_time1_end,
      in_line_time2_start: info.in_line_time2_start,
      in_line_time2_end: info.in_line_time2_end,
      note: info.note,
    }
    Vue.set(state, 'shiftInfo', shiftInfo)
  },
  initShiftInfo(state) {
    Object.assign(state.shiftInfo, defaultState.shiftInfo)
  },
  setAutoLocation(state, autoLocation) {
    Vue.set(state, 'autoLocation', autoLocation)
  },
  setMapCenter(state, mapCenter) {
    Vue.set(state, 'mapCenter', mapCenter)
  },
  setActiveTab(state, activeTab) {
    Vue.set(state, 'activeTab', activeTab)
  },
  setDriverTabAddr(state, driverTabAddr) {
    Vue.set(state, 'driverTabAddr', driverTabAddr)
  },
  initDriverTabAddr(state) {
    Vue.set(state, 'driverTabAddr', '')
  },
  setIsTabLoading(state, isTabLoading) {
    Vue.set(state, 'isTabLoading', isTabLoading)
  },
  setIsTrack(state, isTrack) {
    Vue.set(state, 'isTrack', isTrack)
  },
  setCancelAddrRequest(state, cancel) {
    Vue.set(state, 'cancelAddrRequest', cancel)
  },
}



// WEBPACK FOOTER //
// ./src/store/driverMonitor/mutations.js